export default __webpack_public_path__ + "static/media/photo--sm--137.20df4997.jpg";